export const MAJOR_STATES = ({
  REVIEW: 'Review',
  EDIT: 'Edit',
  META_REVIEW: 'MetaReview'
} as const);
export const TASK_VIEW_TABLE_COLUMNS = ['Global TaskId', 'Name', 'Last State', 'Last Status', 'Assigned To', 'Duration', 'FrameRate', 'Total Frames', 'Created At', 'Updated At'];
export const TASK_STATES_VIEW_TABLE_COLUMNS = ['Task Id', 'Global TaskId', 'Name', 'State', 'Status', 'Assigned To', 'Paused Time', 'Assigned Time', 'Auto Paused Count', 'Created At', 'Updated At'];
export const TASK_TYPE = ({
  WORK: 'Work',
  PREVIEW: 'Preview'
} as const);
export const SUBMIT_TASK_ACTION = ({
  COMPLETE: 'complete',
  PAUSE: 'pause'
} as const);